import React, {useEffect, useMemo, useRef, useState} from "react";
import useMouse from "@react-hook/mouse-position";

import {useDispatch, useSelector} from "react-redux";
import {IFlyerRuntimePage} from "../../../../dtos/flyer";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import {getHeightandWidthOfFlyerPage} from "./utils";
import {IAppState} from "../../../../store/models";
import {zoomIn} from "../../../../store/actionsCreator/zoomActionCreators";
import {Box, CircularProgress} from "@mui/material";
import {makeStyles} from '@mui/styles';
import zoom from '../../../../assets/icons/zoom.png'
import {isMobile} from 'react-device-detect';
import {PageFrame} from "./pageFrame";
// import {AsyncImage} from "../../../imageComponent/image";
import {LazyLoadImage} from 'react-lazy-load-image-component';


const useStyles = makeStyles(() => ({
    flyerBoxPage: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: `100%`,
        padding: `30px 0`,
        '& svg': {
            maxHeight: `100%`
        }
    },
    pageFlyerWrapper: {
        boxSizing: `border-box`,
        height: "100%",
        position: "relative",
        backgroundColor: `#ffffff`,
        '&.default_cursor': {
            cursor: 'default'
        }
    },
    page: {
        backgroundRepeat: `no-repeat`,
        backgroundSize: `100%`,
        height: "100%",
        position: `relative`,
        backgroundPosition: `center`,
    },
}))

type Props = {
    onClick?: (callback: any) => void;
    page: IFlyerRuntimePage;
    handleInternalZooming: boolean;
    contentForMobile?: any;
    sliderRef?: any;
    isSecondPage?: boolean;
    isOnePage?: boolean
    // handleIncrease(): void;
};
const Flyer: React.FC<Props> = ({
                                    page,
                                    handleInternalZooming,
                                    contentForMobile,
                                    sliderRef,
                                    isSecondPage = false,
                                    isOnePage = false
                                }) => {
    const dispatch = useDispatch();
    const framesWrapperRef = useRef<HTMLElement>(null);
    const {isMultipage, isFullScreen} = useSelector(
        (state: IAppState) => state.controlsBranch
    );
    const {flyersBranch} = useSelector(
        (state: IAppState) => state
    );
    const [pageState, setPageState] = useState<IFlyerRuntimePage>(page);
    const [customStyles, setCustomStyles] = useState<React.CSSProperties>();

    const {height: windowHeight, width: windowWidth} = useWindowDimensions();
    // const isVerticalScrolling = true;
    // const isOnePageOrientation: boolean = false;
    const isVerticalScrolling = flyersBranch.data?.pageLayoutPc === 2 || flyersBranch.data?.pageLayoutPc === 3;
    const isOnePageOrientation: boolean = flyersBranch.data?.pageLayoutPc === 3 || flyersBranch.data?.pageLayoutPc === 4;
    const isHebrew: boolean = flyersBranch.data?.dir.toLowerCase() === "rtl";
    const flyerType = flyersBranch.data?.typeCode;
    const [isFirstLoading, setIsFirstLoading] = useState<boolean>(true);
    useEffect(() => {
        setIsFirstLoading(true);
        setTimeout(() => {
            setIsFirstLoading(false);
        }, 500)
    }, []);

    // const isMobile = useMediaQuery("(max-width:767px)", {noSsr: true});
    const {height, width} = useMemo(
        () =>
            getHeightandWidthOfFlyerPage(
                pageState,
                windowHeight,
                windowWidth,
                isMobile,
                isFullScreen
            ),
        [pageState, windowHeight, windowWidth, isMobile, isFullScreen]
    );
    const {zoomBranch} = useSelector((state: IAppState) => state);
    const parentDivRef = useRef<HTMLDivElement>(null);

    const mouse = useMouse(parentDivRef, {
        enterDelay: 100,
        leaveDelay: 100,
    });

    const classes = useStyles();

    useEffect(() => {
        let parentStyles: React.CSSProperties = {
            // overflow: 'hidden',
            border: `1px solid #bfbfbf`,
            borderLeft: isMobile ? "1px solid #bfbfbf" : isSecondPage && !isHebrew ? "none" : isSecondPage && isHebrew ? "1px solid #bfbfbf" : isOnePage ? "1px solid #bfbfbf" : isHebrew ? "none" : "1px solid #bfbfbf",
            borderRight: isMobile ? "1px solid #bfbfbf" : isSecondPage && !isHebrew ? "1px solid #bfbfbf" : isSecondPage && isHebrew ? "none" : isOnePage ? "1px solid #bfbfbf" : isHebrew ? "1px solid #bfbfbf" : "none",
            cursor: isVerticalScrolling ? `default` : `url(${zoom}), auto`,

        };
        if (handleInternalZooming) {
            parentStyles = {
                ...parentStyles,
                transformOrigin: `${zoomBranch.pivotX * 100.0}% ${
                    zoomBranch.pivotY * 100.0
                }%`,
                transform: `scale(${1 + zoomBranch.scale}, ${1 + zoomBranch.scale})`,
                // transition: '1s ease-in-out'
            };
        }
        setCustomStyles(parentStyles);
    }, [handleInternalZooming, isMobile, isSecondPage, isHebrew, isOnePage, isVerticalScrolling, zoomBranch])

    useEffect(() => {
        setPageState(page);
    }, [page.pageId]);

    const calculateSpotHeightAndWidth = ({
                                             spotX0PX,
                                             spotX1PX,
                                             spotY0PX,
                                             spotY1PX,
                                         }: any, currentPageSelector: HTMLElement) => {
        const constantHeight = pageState.heightPx / (spotY1PX - spotY0PX);
        const constantWidth = pageState.widthPx / (spotX1PX - spotX0PX);
        const paddingHeight = isFullScreen ? 106 : 200;
        let spotHeight;
        let spotWidth;
        let top;
        let left;

        const FLYER_PAPER_PAGE_WIDTH = pageState.widthPx;
        const FLYER_PAPER_PAGE_HEIGHT = pageState.heightPx;
        // const FLYER_PAPER_PAGE_WIDTH = 1388.0;
        // const FLYER_PAPER_PAGE_HEIGHT = 1772.0;

        // let pageWidth = $('.flyer_page_image_container').innerWidth();
        // let pageHeight = $('.flyer_page_image_container').innerHeight();

        // const currentPageSelector = $(
        //     `.${styles.flyerPageImageContainer}${page.pageId}`
        // );
        let pageWidth = currentPageSelector.clientWidth;
        let pageHeight = currentPageSelector.clientHeight;
        // let pageWidth = currentPageSelector.innerWidth();
        // let pageHeight = currentPageSelector.innerHeight();

        let scaleX = pageWidth! / FLYER_PAPER_PAGE_WIDTH;
        let scaleY = pageHeight! / FLYER_PAPER_PAGE_HEIGHT;

        if (isMobile) {
            spotWidth = (width - 10) / constantWidth;
            spotHeight = height / constantHeight;
        } else {
            spotWidth = width / constantWidth;
            spotHeight = (windowHeight - paddingHeight) / constantHeight;
        }

        if (isMultipage && isMobile) {
            top = spotY0PX / ((spotY1PX - spotY0PX) / spotHeight) / 2;
            left = spotX0PX / ((spotX1PX - spotX0PX) / spotWidth) / 2;
            spotWidth = spotWidth / 2;
            spotHeight = spotHeight / 2;
        } else {
            // top = (spotY0PX / ((spotY1PX - spotY0PX) / spotHeight)) * zoomScale;
            // left = (spotX0PX / ((spotX1PX - spotX0PX) / spotWidth)) * zoomScale;

            // top = (spotY0PX / ((spotY1PX - spotY0PX) / spotHeight));
            // left = (spotX0PX / ((spotX1PX - spotX0PX) / spotWidth));

            left = spotX0PX * scaleX;
            top = spotY0PX * scaleY;

            spotWidth = (spotX1PX - spotX0PX) * scaleX;
            spotHeight = (spotY1PX - spotY0PX) * scaleY;

            // spotHeight = spotHeight * zoomScale;
            // spotWidth = spotWidth * zoomScale;
        }


        return {
            spotHeight,
            spotWidth: spotWidth,
            top: top - 1,
            left: left - 1,
        };
    };

    const handleZoomClick = () => {
        if (!handleInternalZooming) {
            return;
        }

        let targetScale = zoomBranch.scale + 1;
        // let targetScale = zoomBranch.scale + 1 / 2.0;


        let globalMousePosition = mouse;

        let mouseX = globalMousePosition.x!;
        let mouseY = globalMousePosition.y!;
        let currentWidth = width;
        let currentHeight = height;
        let percentX = mouseX / currentWidth;
        let percentY = mouseY / currentHeight;

        if (percentX >= 1) {
            percentX = 1;
        } else if (percentX <= -1) {
            percentX = -1;
        }

        if (percentY >= 1) {
            percentY = 1;
        } else if (percentY <= -1) {
            percentY = -1;
        }

        dispatch(
            zoomIn({
                x: 0,
                y: 0,
                pivotX: percentX,
                pivotY: percentY,
                scale: targetScale,
            })
        );
    };

    const frames = useMemo(() => {
        if (!pageState.spots) {
            return [];
        }
        return pageState.spots.map((frame, i) => {
            const {frameType, promo, spotId} = frame;
            const currentPageSelector = framesWrapperRef.current as HTMLElement;
            if (!currentPageSelector) {
                return;
            }

            const frameCoordinates = calculateSpotHeightAndWidth(frame, currentPageSelector);
            const shouldRender =
                (flyerType === 1 && frameType !== 1) ||
                (flyerType !== 1 && ((frameType === 1 && promo) || frameType !== 1));

            if (!shouldRender) {
                return;
            }

            return (
                <PageFrame
                    key={spotId}
                    page={pageState}
                    frame={frame}
                    frameCoordinates={frameCoordinates}
                    frameIndex={i}
                    contentForMobile={contentForMobile}
                    sliderRef={sliderRef}
                    framesWrapperRef={framesWrapperRef}
                />
            );
        })
    }, [pageState.spots, flyerType, contentForMobile, sliderRef, framesWrapperRef.current, framesWrapperRef.current?.clientWidth, framesWrapperRef.current?.clientHeight]);

    if (!pageState) {
        return <div></div>;
    }
    return (
        <Box
            ref={parentDivRef}
            onClick={() => {
                if (!isFullScreen && !isVerticalScrolling) {
                    handleZoomClick();
                }
            }}
            className={`${classes.pageFlyerWrapper} ${isFullScreen ? `default_cursor` : ""}`}
            // className={`${styles.item} ${isFullScreen ? styles.default_cursor : ""}`}
            style={customStyles}
        >
            {isFirstLoading &&
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "100%",
                        height: "100%",
                        zIndex: 2,
                    }}
                >
                    <Box sx={{
                        height: "100%",
                        width: "100%",
                        position: "relative",
                        backgroundColor: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1,
                    }}>
                        <CircularProgress sx={{color: "rgb(25, 118, 210)"}}/>
                    </Box>
                </Box>
            }
            <Box ref={framesWrapperRef} className={`${classes.page}`}>
                <Box
                    sx={{
                        width: "100%",
                        height: isVerticalScrolling && isOnePageOrientation && !isMobile ? "100%" : "100%",
                        backgroundColor: page.displayImageUrl.match(/(.jpg|.jpeg|.webp)/) ? "#0000000A" : "#ffffff"
                    }}
                >
                    <Box
                        sx={{
                            width: "100%",
                            height: isVerticalScrolling && isOnePageOrientation && !isMobile ? "100%" : "100%"
                        }}
                    >
                        {
                            pageState?.displayImageUrl.match(/(.jpg|.jpeg|.webp)/) &&
                            <>
                                {
                                    (isOnePageOrientation || isMobile) &&
                                    <img
                                        alt=""
                                        height={"100%"}
                                        src={pageState?.displayImageUrl || ""}
                                        width={"100%"}
                                    />
                                }
                                {
                                    (!isOnePageOrientation && !isMobile) &&
                                    <LazyLoadImage
                                        effect={"opacity"}
                                        data-lazy={pageState?.displayImageUrl}
                                        placeholderSrc={pageState?.thumbnailImageUrl || ""}
                                        alt={pageState?.thumbnailImageUrl || ""}
                                        height={"100%"}
                                        src={pageState?.displayImageUrl || ""}
                                        width={"100%"}
                                    />
                                }
                            </>
                        }
                    </Box>
                </Box>
                {!isFullScreen && (
                    <Box
                        sx={{
                            position: "absolute",
                            top: 0,
                            display: "flex",
                            width: "100%",
                            height: isVerticalScrolling && isOnePageOrientation && !isMobile ? "100%" : "100%",
                            backgroundColor: page.displayImageUrl.match(/(.jpg|.jpeg|.webp)/) ? "#0000000A" : "#ffffff"
                        }}
                    >
                        {!isFirstLoading && frames}
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default Flyer;
